import { FbmResource } from 'models/fbm-resource/_types';
import { Identifier, Timestamp } from 'types/utilityTypes';

export enum WaitListType {
  FirstComeFirstServe = 'first_come_first_serve',
  AutoAdd = 'auto_add',
}

export type PercentageBase = 'unit_price' | 'pretax_price' | 'total_due';

export interface Service {
  id: Identifier;
  name: string;
  description: string;
  thumbnail: string;
  largeThumbnail: string;
  waitlist: boolean; // this service supports waitlisting
  defaultTime: number; // default time in minutes
  showBooked: boolean; // can i show other users to non-trainers
  disableCancellations: boolean; // can i cancel this appointment
  waitlistType: WaitListType;
  waitlistCap: number;
  cancellationPolicyHours: number;
  autoChargeCancellation: boolean;
  cancellationFee: number;
  usesCalendar: boolean;
  calendarId: string;
  serviceType: string;
  tags: string[];
  primaryTrainerIds: Identifier[];
  secondaryTrainerIds: Identifier[];
  serviceCode: string;
  price: number;
  noshowFee: string;
  defaultPackageId: string;
  defaultCommissionType: string;
  defaultCommission: string;
  defaultBaseRate?: number | string;
  defaultAttendeeTiers?: { min: number; max: number | null; amount: number }[];
  defaultSecondaryCommissionType: string;
  defaultSecondaryCommission: string;
  defaultSecondaryBaseRate?: number | string;
  defaultSecondaryAttendeeTiers?: { min: number; max: number | null; amount: number }[];
  defaultPayStaffZeroAttendees?: boolean;
  defaultSecondaryPayStaffZeroAttendees?: boolean;
  defaultPayStaffNoShow?: boolean;
  defaultSecondaryPayStaffNoShow?: boolean;
  defaultPercentageBase?: PercentageBase | null;
  defaultSecondaryPercentageBase?: PercentageBase | null;
  serviceResources: {
    id: Identifier;
    serviceId: Identifier;
    subResourceIds: Identifier[];
    usageBehavior: string;
    resource: FbmResource;
  }[];
  classpass: boolean;
  public: boolean;

  closeSignupHoursBefore: number;
  maxVisitsPerDay: string;
  requirePrepayment: boolean;
  freeClasses: number;
  freeClassPackage: boolean;
  preventVisitWithoutPackage: boolean;
  newAccountsOnly: boolean;
  bookRecurringSession: boolean;
  bookWithoutAccount: boolean;
  noCardRequired: boolean;
  freeSignups: boolean;
  hideStaff: boolean;
  hideLocation: boolean;
  disableBooking: boolean;
  clientSelectSubAsset: boolean;
  media: string;
  maxVisits: string;
  minimumVisits: string;
  classpassMaxVisits: string;
  locationLimits: {
    locationId: Identifier;
    maxVisits: number;
    classpassMaxVisits?: number;
  }[];
  uniqueZoomLink: boolean;
  zoom: {
    password: string;
    description: string;
    autoRecording: string;
    joinBeforeHost: boolean;
    muteUponEntry: boolean;
    waitingRoom: boolean;
  } | null;
  color: string;
  completedColor: string;
  allCompletedColor: string;
  unpaidColor: string;
  cancelledColor: string;
  defaultColor: string;
  registeredColor: string;
  lateCancelledColor: string;
  noShowColor: string;
  assessmentId: Identifier;
  assessmentSequenceId: Identifier;
  createdAt?: Timestamp;
  deletedAt?: string | null;
}

